import { SupportedLanguage } from "../types/lang.type";

export const roundTypeAlias: Record<SupportedLanguage, Record<string, string>> = {
  "en": {
    'answer': 'Text Answer',
    'one-of-many': 'One of Many',
    'more-accurate': 'More Accurate',
    'correct-order': 'Correct Order',
    'match-items': 'Match Items',
    'what-common': 'What Common',
    'odd-item': 'Odd Item',
    'sequence': 'Complete List',
    'true-false': 'True or False',
    'alias': 'Alias',
    'charades': 'Charades',
    'pictionary': 'Pictionary'
  } as const,
  "ru": {
    'answer': 'Текстовый ответ',
    'one-of-many': 'Правильный вариант',
    'more-accurate': 'Кто точнее',
    'correct-order': 'Правильный порядок',
    'match-items': 'Соответствие',
    'what-common': 'Что общего',
    'odd-item': 'Что лишнее',
    'sequence': 'Дополните список',
    'true-false': 'Правда или ложь',
    'alias': 'Алиас',
    'charades': 'Показуха',
    'pictionary': 'Нарисуй слово'
  } as const,
  "uk": {
    'answer': 'Текстова відповідь',
    'one-of-many': 'Один з кількох',
    'more-accurate': 'Кто точніше',
    'correct-order': 'Правильний порядок',
    'match-items': 'Співпадення',
    'what-common': 'Що спільного',
    'odd-item': 'Що зайве',
    'sequence': 'Доповніть список',
    'true-false': 'Правда чи брехня',
    'alias': 'Аліас',
    'charades': 'Показуха',
    'pictionary': 'Нарисуй слово'
  } as const,
  "es": {
    'answer': 'Respuesta',
    'one-of-many': 'Uno de muchos',
    'more-accurate': 'Más preciso',
    'correct-order': 'Orden correcto',
    'match-items': 'Coincidencia',
    'what-common': '¿Qué en común?',
    'odd-item': '¿Qué es superfluo?',
    'sequence': 'Completar lista',
    'true-false': 'Verdadero o falso',
    'alias': 'Alias',
    'charades': 'Charades',
    'pictionary': 'Pictionary'
  } as const
};

export const educationalLevel = {
  'easy': 'Beginner',
  'medium': 'Intermediate',
  'hard': 'Advanced',
  'expert': 'Advanced',
  'customizable': 'Intermediate'
} as const;

export const roundTypeShort = {
  'answer': 'TA',
  'one-of-many': 'OM',
  'more-accurate': 'MA',
  'correct-order': 'CO',
  'match-items': 'MI',
  'what-common': 'WC',
  'odd-item': 'OI',
  'sequence': 'CL',
  'true-false': 'TF',
  'alias': 'AL',
  'charades': 'CA',
  'pictionary': 'PI'
} as const;
